import React from "react";

import { Flex, Icon, Typography } from "components";

export type CropFilterEmptyStateProps = {
  message: string;
  dataTestId?: string;
};

export const CropFilterEmptyState = ({ message, dataTestId }: CropFilterEmptyStateProps) => (
  <Flex vertical align="center" gap="1.5rem" className="crop-filter-empty-state" data-testid={dataTestId}>
    <Icon iconName="klim/crop-rotation" size="xl" className="crop-filter-empty-state-icon" />
    <Typography variant="paragraph-m">{message}</Typography>
  </Flex>
);

export default CropFilterEmptyState;
